import React, { useEffect, useState } from "react";
import axios from "axios";
import { domainServer } from "../constant/domain.js";
import {
  useLoginMutation,
  useSendOtpMutation,
} from "../store/mutations/auth.mutate.js";
import LoadingFullscreen from "../components/Common/Loading/LoadingFullscreen.js";
import { useGetMeQuery } from "../store/queries/auth.query.js";
import APIs from "../constant/endpoint.js";
import { generateTokenFromProtoken } from "../helpers/login.helper.js";
import { Link, useNavigate } from "react-router-dom";
import { REGEX_EMAIL, USERNAME_REGEX } from "../constant/regex.js";
import { socket } from "../helpers/socket.helper.js";

function App() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [usernamereg, setUsernameReg] = useState("");
  const [passwordreg, setPasswordReg] = useState("");
  const [emailreg, setEmaildReg] = useState("");
  const [message, setMessage] = useState("");
  const [registerMessage, setRegisterMessage] = useState("");
  const [processing, setProcessing] = useState(false); // Track processing state
  const [toggleLogin, setToggleLogin] = useState(false);

  const { mutateAsync: mutateLogin, isPending, isSuccess } = useLoginMutation();
  const { isLoading, data, isSuccess: getMeSuccess } = useGetMeQuery();

  const { isPending: isSending } = useSendOtpMutation();

  useEffect(() => {
    if (getMeSuccess && data) {
      socket.emit("disconnect_vip_rent_order", {
        userId: data.id,
      });

      // Token already exists, redirect to home
      navigate("/");
    }
  }, [isLoading, data]);

  const handleRegister = async () => {
    // Trim whitespace from input values
    const trimmedUsername = usernamereg.trim();
    const trimmedPassword = passwordreg.trim();
    const trimmedConfirmPassword = confirmPassword.trim();
    const trimmedEmail = emailreg.trim(); // Include email field

    // Check if all fields are filled out
    if (
      !trimmedUsername ||
      !trimmedPassword ||
      !trimmedConfirmPassword ||
      !trimmedEmail
    ) {
      setRegisterMessage("Vui lòng nhập đầy đủ thông tin");
      return;
    }

    if (!USERNAME_REGEX.test(trimmedUsername)) {
      setRegisterMessage("Tên người dùng không chứa kí tự đặc biệt");
      return;
    }
    if (trimmedUsername.length <= 5 || trimmedUsername.length >= 15) {
      setRegisterMessage(
        "Tên người dùng không được ít hơn 5 ký tự hoặc quá 15 ký tự"
      );
      return;
    }

    if (!REGEX_EMAIL.test(trimmedEmail)) {
      setRegisterMessage("Vui lòng nhập email hợp lệ");
      return;
    }

    // Check if passwords match
    if (trimmedPassword !== trimmedConfirmPassword) {
      setRegisterMessage("Mật khẩu không khớp ");
      return;
    }

    try {
      setProcessing(true); // Set processing state to true
      const response = await axios.post(
        `${domainServer}${APIs.register}`,
        {
          usernamereg: trimmedUsername,
          passwordreg: trimmedPassword,
          emailreg: trimmedEmail,
        },
        { withCredentials: false }
      );
      if (response.data) setRegisterMessage(response.data);
      if (response) {
        // Email verification is disabled: the account is active right away
        setUsername(trimmedUsername);
        setPassword("");
      }
    } catch (error) {
      setRegisterMessage(error?.response?.data);
    } finally {
      setProcessing(false);
    }
  };

  const handleLogin = async () => {
    // Trim whitespace from input values
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername || !trimmedPassword) {
      setMessage("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    try {
      setProcessing(true); // Set processing state to true
      const response = await mutateLogin({
        username: trimmedUsername,
        password: trimmedPassword,
      });
      setMessage(response.message);
      if (response.token) {
        localStorage.setItem("accessToken", response.token);
        // Redirect to home after login
        setTimeout(() => {
          navigate("/");
        }, 1000);
      }
    } catch (error) {
      // Email verification is disabled: never send the user to the OTP screen
      setMessage(error?.response?.data.message);
    } finally {
      setProcessing(false); // Set processing state to false when done
    }
  };

  useEffect(() => {
    if (window?.electron?.receiveFromMain) {
      window.electron.receiveFromMain("open-url", (protocoUrl) => {
        const token = generateTokenFromProtoken(protocoUrl);
        if (token) navigate(`/verify/${token}`);
      });
    }
  }, []);

  return (
    <div className="overflow-hidden">
      <LoadingFullscreen
        loading={isPending || isSuccess || isLoading}
        className={`-top-32 ${(isSuccess || isLoading) && "!bg-bgPrimary"}`}
      />
      <meta charSet="UTF-8" />
      <link
        rel="apple-touch-icon"
        type="image/png"
        href="https://cpwebassets.codepen.io/assets/favicon/apple-touch-icon-5ae1a0698dcc2402e9712f7d01ed509a57814f994c660df9f7a952f3060705ee.png"
      />
      <meta name="apple-mobile-web-app-title" content="CodePen" />
      <link
        rel="shortcut icon"
        type="image/x-icon"
        href="https://cpwebassets.codepen.io/assets/favicon/favicon-aec34940fbc1a6e787974dcd360f2c6b63348d4b1f4e06c77743096d55480f33.ico"
      />
      <link
        rel="mask-icon"
        type="image/x-icon"
        href="https://cpwebassets.codepen.io/assets/favicon/logo-pin-b4b4269c16397ad2f0f7a01bcdf513a1994f4c94b8af2f191c09eb0d601762b1.svg"
        color="#111"
      />
      <title>Đăng nhập</title>
      <link rel="canonical" href="https://codepen.io/ig_design/pen/KKVQpVP" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.5.0/css/bootstrap.min.css"
      />
      <link
        rel="stylesheet"
        href="https://unicons.iconscout.com/release/v2.1.9/css/unicons.css"
      />
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n/* Please ❤ this if you like it! */\n\n\n@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700,800,900');\n\nbody{\n\tfont-family: 'Poppins', sans-serif;\n\tfont-weight: 300;\n\tfont-size: 15px;\n\tline-height: 1.7;\n\tcolor: #c4c3ca;\n\tbackground-color: #1f2029;\n\toverflow-x: hidden;\n}\na {\n\tcursor: pointer;\n  transition: all 200ms linear;\n}\na:hover {\n\ttext-decoration: none;\n}\n.link {\n  color: #c4c3ca;\n}\n.link:hover {\n  color: #ffeba7;\n}\np {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.7;\n}\nh4 {\n  font-weight: 600;\n}\nh6 span{\n  padding: 0 20px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.section{\n  position: relative;\n  width: 100%;\n  display: block;\n}\n.full-height{\n  min-height: 100vh;\n}\n[type=\"checkbox\"]:checked,\n[type=\"checkbox\"]:not(:checked){\n  position: absolute;\n  left: -9999px;\n}\n.checkbox:checked + label,\n.checkbox:not(:checked) + label{\n  position: relative;\n  display: block;\n  text-align: center;\n  width: 60px;\n  height: 16px;\n  border-radius: 8px;\n  padding: 0;\n  margin: 10px auto;\n  cursor: pointer;\n  background-color: #ffeba7;\n}\n.checkbox:checked + label:before,\n.checkbox:not(:checked) + label:before{\n  position: absolute;\n  display: block;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  color: #ffeba7;\n  background-color: #102770;\n  font-family: 'unicons';\n  content: '\\eb4f';\n  z-index: 20;\n  top: -10px;\n  left: -10px;\n  line-height: 36px;\n  text-align: center;\n  font-size: 24px;\n  transition: all 0.5s ease;\n}\n.checkbox:checked + label:before {\n  transform: translateX(44px) rotate(-270deg);\n}\n\n\n.card-3d-wrap {\n  position: relative;\n  width: 440px;\n  max-width: 100%;\n  height: 428px;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  perspective: 800px;\n  margin-top: 60px;\n}\n.card-3d-wrapper {\n  width: 100%;\n  height: 100%;\n  position:absolute;    \n  top: 0;\n  left: 0;  \n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  transition: all 600ms ease-out; \n}\n.card-front, .card-back {\n  width: 100%;\n  height: 100%;\n  background-color: #2a2b38;\n  background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/1462889/pat.svg');\n  background-position: bottom center;\n  background-repeat: no-repeat;\n  background-size: 300%;\n  position: absolute;\n  border-radius: 6px;\n  left: 0;\n  top: 0;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  -o-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n.card-back {\n  transform: rotateY(180deg);\n}\n.checkbox:checked ~ .card-3d-wrap .card-3d-wrapper {\n  transform: rotateY(180deg);\n}\n.center-wrap{\n  position: absolute;\n  width: 100%;\n  padding: 0 35px;\n  top: 50%;\n  left: 0;\n  transform: translate3d(0, -50%, 35px) perspective(100px);\n  z-index: 20;\n  display: block;\n}\n\n\n.form-group{ \n  position: relative;\n  display: block;\n    margin: 0;\n    padding: 0;\n}\n.form-style {\n  padding: 13px 20px;\n  padding-left: 55px;\n  height: 48px;\n  width: 100%;\n  font-weight: 500;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0.5px;\n  outline: none;\n  color: #c4c3ca;\n  background-color: #1f2029;\n  border: none;\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n  box-shadow: 0 4px 8px 0 rgba(21,21,21,.2);\n}\n.form-style:focus,\n.form-style:active {\n  border: none;\n  outline: none;\n  box-shadow: 0 4px 8px 0 rgba(21,21,21,.2);\n}\n.input-icon {\n  position: absolute;\n  top: 0;\n  left: 18px;\n  height: 48px;\n  font-size: 24px;\n  line-height: 48px;\n  text-align: left;\n  color: #ffeba7;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n\n.form-group input:-ms-input-placeholder  {\n  color: #c4c3ca;\n  opacity: 0.7;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input::-moz-placeholder  {\n  color: #c4c3ca;\n  opacity: 0.7;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input:-moz-placeholder  {\n  color: #c4c3ca;\n  opacity: 0.7;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input::-webkit-input-placeholder  {\n  color: #c4c3ca;\n  opacity: 0.7;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input:focus:-ms-input-placeholder  {\n  opacity: 0;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input:focus::-moz-placeholder  {\n  opacity: 0;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input:focus:-moz-placeholder  {\n  opacity: 0;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n.form-group input:focus::-webkit-input-placeholder  {\n  opacity: 0;\n  -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n}\n\n.btn{  \n  border-radius: 4px;\n  height: 44px;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  -webkit-transition : all 200ms linear;\n  transition: all 200ms linear;\n  padding: 0 30px;\n  letter-spacing: 1px;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n  -ms-justify-content: center;\n  justify-content: center;\n  -ms-flex-pack: center;\n  text-align: center;\n  border: none;\n  background-color: #ffeba7;\n  color: #102770;\n  box-shadow: 0 8px 24px 0 rgba(255,235,167,.2);\n}\n.btn:active,\n.btn:focus{  \n  background-color: #102770;\n  color: #ffeba7;\n  box-shadow: 0 8px 24px 0 rgba(16,39,112,.2);\n}\n.btn:hover{  \n  background-color: #102770;\n  color: #ffeba7;\n  box-shadow: 0 8px 24px 0 rgba(16,39,112,.2);\n}\n\n\n\n\n.logo {\n\tposition: absolute;\n\ttop: 30px;\n\tright: 30px;\n\tdisplay: block;\n\tz-index: 100;\n\ttransition: all 250ms linear;\n}\n.logo img {\n\theight: 26px;\n\twidth: auto;\n\tdisplay: block;\n}\n",
        }}
      />

      <div className="section">
        <div className="container">
          <div className="row full-height justify-content-center">
            <div className="col-12 text-center">
              <div className="section pb-5 pt-4 text-center">
                <h6 className="mb-0 pb-2">
                  <span
                    className="text-warning cursor-pointer"
                    onClick={() => setToggleLogin(!toggleLogin)}
                  >
                    Đăng nhập{" "}
                  </span>
                  <span
                    className="text-danger cursor-pointer"
                    onClick={() => setToggleLogin(!toggleLogin)}
                  >
                    Đăng ký
                  </span>
                </h6>
                <input
                  className="checkbox"
                  type="checkbox"
                  id="reg-log"
                  name="reg-log"
                  checked={toggleLogin}
                  onChange={() => setToggleLogin(!toggleLogin)}
                />
                <label htmlFor="reg-log" />
                <div className="card-3d-wrap mx-auto mt-4">
                  <div className="card-3d-wrapper">
                    <div className="card-front">
                      <div className="center-wrap w-full">
                        <div className="section text-center">
                          <h4>Đăng nhập - Red Father Gaming App</h4>
                          <p>
                            Hệ thống thuê tài khoản game bản quyền Red Father Gaming App
                          </p>
                          <div className="pt-1">
                            <div className="form-group">
                              <input
                                value={username}
                                className="form-style"
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Nhập tài khoản"
                                autoComplete="off"
                              />
                              <i className="input-icon uil uil-user" />
                            </div>
                            <div className="form-group mt-2">
                              <input
                                type="password"
                                value={password}
                                className="form-style"
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Nhập mật khẩu"
                                autoComplete="off"
                              />
                              <i className="input-icon uil uil-lock-alt" />
                            </div>
                          </div>
                          <button
                            onClick={handleLogin}
                            className={`btn mt-4 ${
                              processing || isSending ? "disabled" : ""
                            }`}
                            disabled={processing || isSending}
                          >
                            {processing || isSending
                              ? "Đang xử lý..."
                              : "Đăng nhập"}
                          </button>
                          <p className="mt-2">{message}</p>
                          <p className="text-center">
                            <Link to="/forgot-password" className="link">
                              Quên mật khẩu?
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card-back ">
                      <div className=" relative w-100 h-[440px] top-1 left-0 z-20 block ">
                        <div className="section text-center">
                          <h4 className="pt-3">Đăng ký - Red Father Gaming App</h4>
                          <p>
                            Hệ thống thuê tài khoản game bản quyền Red Father Gaming App
                          </p>
                          <div className="px-8">
                            <div className="form-group">
                              <input
                                type="text"
                                value={usernamereg}
                                className="form-style"
                                onChange={(e) => setUsernameReg(e.target.value)}
                                placeholder="Nhập tài khoản..."
                                autoComplete="off"
                                required
                              />
                              <i className="input-icon uil uil-user" />
                            </div>
                            <div className="form-group mt-2">
                              <input
                                type="password"
                                value={passwordreg}
                                className="form-style"
                                onChange={(e) => setPasswordReg(e.target.value)}
                                placeholder="Nhập mật khẩu..."
                                autoComplete="off"
                                required
                              />
                              <i className="input-icon uil uil-lock" />
                            </div>
                            <div className="form-group mt-2">
                              <input
                                type="password"
                                value={confirmPassword}
                                className="form-style"
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                                autoComplete="off"
                                placeholder="Xác nhận mật khẩu..."
                                required
                              />
                              <i className="input-icon uil uil-lock" />
                            </div>
                            <div className="form-group mt-2">
                              <input
                                type="email"
                                value={emailreg}
                                className="form-style"
                                onChange={(e) => setEmaildReg(e.target.value)}
                                autoComplete="off"
                                placeholder="Nhập email..."
                                required
                              />
                              <i className="input-icon uil uil-at" />
                            </div>
                          </div>
                          <button
                            onClick={handleRegister}
                            className={`btn mt-4 ${
                              processing ? "disabled" : ""
                            }`}
                            disabled={processing}
                          >
                            {processing ? "Đang xử lý..." : "Đăng ký"}
                          </button>
                          {toggleLogin ? (
                            <p className=" mt-1">{registerMessage}</p>
                          ) : (
                            <p className=" mt-1">{message}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
